import React, { useState } from "react";
import { TEAL } from "./constants";
import { IconSparkle, IconChevronLeft, IconChevronRight } from "../../lib/Icons/WhiteboardIcons";

export default function ImagePromptBar({ slot, onGenerate, onCycle, onCommit, onClose, usage }) {
  const [text, setText] = useState(slot?.prompt || "");
  if (!slot) return null;

  const options = slot.options || [];
  const index = slot.index || 0;
  const busy = Boolean(slot.busy);

  const submit = (e) => {
    e.preventDefault();
    if (!text.trim() || busy) return;
    onGenerate(slot.id, text.trim());
  };

  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 top-3 z-[60] rounded-xl border border-black/[0.08] shadow-[0_10px_30px_rgba(0,0,0,0.18)] font-['DM_Sans']"
      style={{ background: "#FFFFFF", width: 420 }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <form onSubmit={submit} className="flex items-center gap-2 px-3 py-[10px]">
        <span style={{ color: TEAL }}><IconSparkle size={18} /></span>
        <input
          autoFocus
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Describe what you want to generate…"
          disabled={busy}
          className="flex-1 text-[13px] bg-transparent border-none outline-none text-slate-700 placeholder:text-slate-400"
        />
        <button type="submit" disabled={busy || !text.trim()}
          className="text-[11px] font-semibold px-3 py-[6px] rounded-md cursor-pointer border-none text-white disabled:opacity-45"
          style={{ background: TEAL }}>
          {busy ? "Working…" : options.length ? "Again" : "Generate"}
        </button>
        <button type="button" onClick={onClose} title="Close"
          className="text-slate-400 text-[15px] leading-none bg-transparent border-none cursor-pointer px-1">
          ✕
        </button>
      </form>

      {options.length > 0 && (
        <div className="flex items-center justify-between gap-2 px-3 pb-[10px]">
          <button type="button" onClick={() => onCycle(slot.id, -1)} disabled={options.length < 2}
            title="Previous option"
            className="w-[28px] h-[28px] rounded-full flex items-center justify-center border border-black/10 bg-white cursor-pointer disabled:opacity-40 text-slate-500">
            <IconChevronLeft size={15} />
          </button>

          <span className="text-[11px] text-slate-400">
            Option {index + 1} of {options.length}
          </span>

          <button type="button" onClick={() => onCycle(slot.id, 1)} disabled={options.length < 2}
            title="Next option"
            className="w-[28px] h-[28px] rounded-full flex items-center justify-center border border-black/10 bg-white cursor-pointer disabled:opacity-40 text-slate-500">
            <IconChevronRight size={15} />
          </button>

          <button type="button" onClick={() => onCommit(slot.id)}
            className="text-[11px] font-semibold px-3 py-[6px] rounded-md cursor-pointer border"
            style={{ color: TEAL, borderColor: "rgba(77,184,181,0.45)", background: "rgba(77,184,181,0.10)" }}>
            Use this one
          </button>
        </div>
      )}

      {usage?.cap ? (
        <div className="px-3 pb-[8px] text-[10px] text-slate-400">
          {usage.used} of {usage.cap} images used today
        </div>
      ) : null}
    </div>
  );
}
